import {
  aggregationsPage,
  reportsPage,
  batchsPage,
  ordersPage,
  cameraPage,
  ukmPage,
  profilePage,
  employeePage,
  linesPage,
  terminalsPage,
  productsPage,
  documentsPage,
} from "./routesInfo"

export const SidebarMenuItem = (route, title, icon, onSelect) => {
  return {
    route: route,
    title: title,
    icon: icon,
    onSelect: onSelect,
  }
}

export const sidebarMenuItems = [
  SidebarMenuItem(profilePage, "Profile"),
  SidebarMenuItem(reportsPage, "Reports"),
  SidebarMenuItem(employeePage, "Employee"),
  SidebarMenuItem(aggregationsPage, "Aggregations"),
  SidebarMenuItem(productsPage, "Products"),
  // SidebarMenuItem(batchsPage, "Batchs"),
  SidebarMenuItem(ordersPage, "Orders"),
  // SidebarMenuItem(cameraPage, "Camera"),
  SidebarMenuItem(linesPage, "Lines"),
  SidebarMenuItem(terminalsPage, "Terminals"),
  SidebarMenuItem(documentsPage, "Documents"),
  SidebarMenuItem(ukmPage, "UKM"),
]
